import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import './styles/tokens/colors.css'
import './styles/tokens/brand.css'
import './styles/tokens/typography.css'
import './styles/tokens/spacing.css'
import './styles.css'

createApp(App).use(router).mount('#app')

// Register the (stub) service worker only in production builds. P0 ships a
// no-op SW; a real caching strategy arrives once the dashboard has real data.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* SW registration is best-effort; ignore failures in P0. */
    })
  })
}
